import $ from 'jquery';

if($("body.member#mypage").length){
	(async () => {
		const character = document.querySelector('.garden .img .character');
		const animations = character.querySelectorAll('.animation');
		const pause = character.querySelector('.pause');
		const anmLen = animations.length;
		const anmData = await Promise.all(Array.from(animations).map(async img => {
			const response = await fetch(img.src);
			const blob = await response.blob();
			return {blob: blob, time: img.getAttribute('data-time')}
		}));
		let timeoutId = null;
		let nextImg;

		function createNextImg() {
			const currentIndex = Math.floor(Math.random() * anmLen) % anmLen;
			const src = URL.createObjectURL(anmData[currentIndex].blob);
			const time = anmData[currentIndex].time;

			const image = document.createElement("img");
			image.src = src;
			image.classList.add('animation');
			image.setAttribute('data-time', time);

			nextImg = image;
		}
		createNextImg();

		function nextCharacterAnimation() {
			if (timeoutId) {
				clearTimeout(timeoutId);
				timeoutId = null;
			}

			const image = nextImg;
			character.querySelectorAll('.animation').forEach(el => {
				URL.revokeObjectURL(el.src);
				character.removeChild(el)
			});
			character.appendChild(image);

			//Firefoxで切り替え時にちらつくので静止画を表示することで対策
			pause.classList.remove('hide');
			setTimeout(() => {
				pause.classList.add('hide');
			}, 50);

			createNextImg();
			timeoutId = setTimeout(nextCharacterAnimation, image.getAttribute('data-time'));
		}

		nextCharacterAnimation();

		document.addEventListener('visibilitychange', () => {
			if (document.visibilityState === 'visible') {
				nextCharacterAnimation();
			}
		});
	})();
}

if($("body.member #characterPopup").length){
	const shuffle = ([...arr]) => {
		let m = arr.length;
		while (m) {
			const i = Math.floor(Math.random() * m--);
			[arr[m], arr[i]] = [arr[i], arr[m]];
		}
		return arr;
	};
	const messagesA = shuffle([
		"認知行動療法は、起きている「出来事」と、個人の反応を「認知」「感情」「身体反応」「行動」の4つに分けて自分を客観的にみて、認知（考え）と行動を工夫して生活しやすくなることを目指す心理療法です。",
		"ポイントは、普段の生活の中で「できて当たり前」と思っていることを書き出すことです。",
		"気分が落ちこむと、つい否定的な考えにとらわれてしまいます。まず「今、気持ちがつらいんだな」と気づくことが、少し楽になるための大切な第一歩です。",
		"寝る前に「3つのいいこと」を書くことで幸せな気持ちになり、寝つきがよくなります（アメリカの心理学者セリグマン教授 の研究）",
		"ポジティブ練習のポイントは、普段の生活の中で「できて当たり前」と思っていることを書き出すことです。",
		"気分が落ち込んでいると、「今日もよいことがなかった」「むだな一日だった」と考えてしまいがち。でも冷静に振り返ってみれば、できたこと、楽しかったこと、感謝することが何か見つかりますよ。",
		"３つの良いことを書き出してみましょう。①自分をほめたいこと②楽しかった/感謝したいこと③子どもをほめたいこと",
		"物事に対して、自分がどのように認知する（考える）か、行動するか、書き出してみると、自分のパターンや「くせ」がわかりますよ。よいパターンはそのままに、変えたほうがよいパターンが見つかったら、「別の考え」「別の行動」に置きかえてみましょう。",
		"イライラ、怒りという感情は誰もが持つものです。決して悪いものではありません。怒りが次の行動の原動力になることもあります。",
		"マインドフルネスとは、「今の瞬間の現実につねに気づきをむけ、その現実をあるがままに感じて、それに対する考えや気持ちにとらわれないでいる心の持ち方」を意味する言葉です",
		"マインドフルネスで、過去（過去）未来（不安）を考えるのではなく、現在（いま・ここ）を考える練習をしましょう。ポイントは①自分の考えや気持ちを観察すること②良い、悪いという評価をしないこと、です",
		"マインドフルネスは、呼吸する、歩く、立つ、座る、食べる、初めての気持ちで物事や人を観察する、など普段の生活の中で行うことができます",
		"マインドフルネスのワーク：１分間、自分の頭に浮かんできた考えの後ろに「ふーん」「へー」「～と思った」という言葉をつけてみましょう。",
		"マインドフルネスのワーク：目の前に流れる川があるイメージで、流れてくる葉っぱの上に自分の考えや感情を一つずつ乗せてみましょう。ゆっくり葉っぱが流れる様子をながめましょう。",
		"マインドフルネスのワーク：空を流れる雲をイメージして、その雲の上に自分の考えや感情を一つずつ乗せてみましょう。ゆっくり雲が流れる様子をながめましょう。",
		"自分に役立つ言葉、考え方、行動を書き出し、自分がご機嫌でいるための「トリセツ」を作って使い続けましょう",
		"身近な信頼できる人（あなたのサポーター）を書き出して整理してみよう。",
		"セルフコンパッションがある人は、自分が失敗した時やつらい気持ちになった時に、自分を責めすぎずに優しくすることができます。",
		"セルフ・コンパッションが身につくと、不安な気持ちや落ちこみが少なくなって、幸せな気持ちになりやすいことが研究でわかっています。",
		"セルフ・コンパッションは、自分自身への優しさや、自分に対して思いやりをもつことです。",
		"スージングタッチは、つらい気持ちの時に、自分で自分の体に優しく触れて、心を落ち着かせる方法です。いつでもどこでも自分をいたわることができる「手当て」です",
		"私たちは、何か出来事が起こり、考え（認知）が浮かんだときに、「でも、こういう考え方もあるかもしれない」「心配だけど、大丈夫だろう」と、自分の考えを見直したり、別の視点から考え直したりすることがあります。これを「認知再構成」とよびます。",
		"認知再構成のヒント：他の人ならどう考えるか、〇〇さんならどう考えるか、子どもの立場ならどう考えるか、など幅広く考えてみます。その中で、自分にとって役に立ちそうな考えを選びましょう。",
		"子どものその行動には、特性が関係しているかもしれません。整理してみましょう。",
		"発達特性「コミュニケーションの苦手さ」には、①相手の気持ちを読み取ったり、自分の気持ちをうまく伝えたりするのが難しい。②言葉を文字通りに理解するので、冗談や応用が苦手、③身振りや表情を読み取るのが苦手で、自分から表情や身振りも少ない、などがあります。",
		"発達特性「行動・興味のかたより」には、①特定の物や行動に強いこだわりを持つ②興味のあることには集中するが、興味がないことにはあきっぽいように見える③急な予定変更などに対応するのが苦手で、嫌がる、パニックになる、などがあります。",
		"発達特性「不注意、衝動性」には、①忘れ物が多い、注意がちりやすい、集中力が続かない。②じっとしているのが苦手で、動きまわったり、やりたいことを我慢できなくて衝動的に行動する、などがあります",
		"アサーティブなコミュニケーションとは、自分と相手の両方を大切にしながら、自分の意見を率直に伝えるコミュニケーションのことです。",
		"だれかにサポートをお願いしたいときは、①事実を伝える②Ｉメッセージ：私は〇〇です③具体的に依頼したいことをシンプルな言葉にすることを心がけることで、より相手に伝わりやすくなります",
		"ストレスがあっても跳ね返す弾性力のある心を「レジリエンス」と呼びます。",
		"発達の特性のある子どもを育てる保護者のストレス回復力（レジリエンス）に関係するものに「子どもについての知識」「社会的支援」「育児への肯定的なとらえ方」の３つがあります。",
	]);

	const messagesB = shuffle([
		"完璧じゃなくて大丈夫！そのままで。",
		"自分にも優しくなろうね。",
		"今日の自分を、たくさん褒めよう。",
		"そのままで、あなたは十分素敵だよ。",
		"自分自身に、優しい言葉をかけてね。",
		"自分を労わる時間を大切にね。",
		"がんばるあなたは素晴らしい。",
		"あなたの努力、ちゃんと見てるよ。",
		"子育ては、毎日が戦場・・・。よく頑張っているね。",
		"いつも本当にありがとうね。感謝。",
		"頑張りすぎないでね。無理は禁物。",
		"毎日毎日、本当によく頑張ってるね。",
		"子どもの成長は、本当に早いね。",
		"ゆっくりでいいんだよ。あなたのペースで。",
		"ほっと一息、あなたのための時間をつくってね",
		"好きなことで、心をゆるめてね。",
		"リラックス法で、自分を癒やそう。",
		"意識的に休むことはとても大切だよ",
		"心と体を、いたわってあげよう。",
		"気分転換は、心の栄養になるよ。",
		"あなたのリラックス法、試してね。",
		"今日は、自分を甘やかす日だよ。",
		"ストレスを感じるのは、あなただけじゃないよ。あなたの立場だったら他の人も同じように、つらいと感じるはず。",
		"つらい気持ちは永遠にはつづかないよ",
		"自分だけが失敗してるって思ってない？みんな同じだよ。",
		"心がつかれたら、自分に優しい言葉をかけてね。熱が出たら、暖かい布団と、消化のよい食事で体をいたわるのと同じだよ。自分につらい言葉をかけるより、いたわったほうが早く元気になるよ。",
		"ゆっくりで大丈夫だよ。話したくなったら聞くからね。",
		"ちょっと一緒に座っていようか。",
		"少しでも気分が良くなるように、何かできることはないかな？",
		"一緒にこの気持ちを乗り越えよう。",
	]);

	const messagesC = shuffle([
		"深呼吸。心に小休止をあげてね。",
		"身近な信頼できる人（あなたのサポーター）を書き出して整理してみよう。",
		"空の雲も、心も流れていくもの。",
		"目の前のことに、集中してみよう。",
		"意識を呼吸に集中！心が落ち着く。",
		"あるがまま、受け入れてみてね。",
		"ストレスを感じたら、休むことも大事。",
		"穏やかな心で、今を感じてみよう。",
		"心のモヤモヤ、誰かに吐き出そう。",
		"マインドフルに、今を感じよう",
		"五感をつかって感じてみると新しい発見があるよ",
		"小さな困りごとは解決のチャンスだよ",
		"一歩ずつ、問題を解決していこう",
		"心の声に、そっと耳を傾けてみて。",
		"失敗は学びのチャンス！大丈夫。",
		"誰かに頼っていいんだよ、いつでも。",
		"状況を具体的に考えてみよう。",
		"どうすれば良くなるかな？考えてみよう。",
		"失敗してもやり直せるよ。大丈夫。",
		"小さな計画を立てて一つ行動してみよう",
		"うーん、おやつ食べたいな、ね！",
		"あれ、今日の夕飯なんだっけ？",
		"ちょっと一休みしない？疲れたらね。",
		"えーと、次はなんだっけ？忘れちゃった。",
		"あ、お腹空いてきちゃったな、ね？",
		"深呼吸で、落ち着きを取り戻そう。",
		"もしかしたら、そうじゃないかも？別の見方も、あるかもしれないね。",
		"本当にそうかな？考えてみよう。視点を変えると、新しい発見があるよ",
		"大丈夫。今の自分にできることをしよう",
		"こういう日もあるよね～。",
	]);

	let nowMessageType = "A";

	function getMessage(){
		let message;
		switch(nowMessageType){
			case "A":
				message = messagesA.shift();
				messagesA.push(message);
				nowMessageType = "B";
				return message;
			case "B":
				message = messagesB.shift();
				messagesB.push(message);
				nowMessageType = "C";
				return message;
			case "C":
				message = messagesC.shift();
				messagesC.push(message);
				nowMessageType = "A";
				return message;
		}
	}

	$("#characterPopup .message .text").text(getMessage());
	$("#characterPopup .img, #characterPopup .message").on("click",async ()=>{
		$("#characterPopup .message .text").text(getMessage());
	});

	(async () => {
		const character = document.querySelector('#characterPopup .img .character');
		const animations = character.querySelectorAll('.animation');
		const pause = character.querySelector('.pause');
		const anmLen = animations.length;
		const anmData = await Promise.all(Array.from(animations).map(async img => {
			const response = await fetch(img.src);
			const blob = await response.blob();
			return {blob: blob, time: img.getAttribute('data-time')}
		}));
		let timeoutId = null;
		let nextImg;

		function createNextImg() {
			const currentIndex = Math.floor(Math.random() * anmLen) % anmLen;
			const src = URL.createObjectURL(anmData[currentIndex].blob);
			const time = anmData[currentIndex].time;

			const image = document.createElement("img");
			image.src = src;
			image.classList.add('animation');
			image.setAttribute('data-time', time);

			nextImg = image;
		}
		createNextImg();

		function nextCharacterAnimation() {
			if (timeoutId) {
				clearTimeout(timeoutId);
				timeoutId = null;
			}

			const image = nextImg;
			character.querySelectorAll('.animation').forEach(el => {
				URL.revokeObjectURL(el.src);
				character.removeChild(el)
			});
			character.appendChild(image);

			//Firefoxで切り替え時にちらつくので静止画を表示することで対策
			pause.classList.remove('hide');
			setTimeout(() => {
				pause.classList.add('hide');
			}, 50);

			createNextImg();
			timeoutId = setTimeout(nextCharacterAnimation, image.getAttribute('data-time'));
		}

		nextCharacterAnimation();

		document.addEventListener('visibilitychange', () => {
			if (document.visibilityState === 'visible') {
				nextCharacterAnimation();
			}
		});
	})();
}